import { REQUEST_STATUS, RequestStatusLabel } from "../constants/status";

/**
 * Maps raw request status to display CSS class status.
 * - W (REQUESTING) → T (PROCESSING) — displays as "Processing"
 * - Q (QUEUED) → T (PROCESSING) — displays as "Processing"
 * - F (FAILED) → Q (QUEUED) — displays as "Requested"
 * - All others pass through unchanged
 */
export const getDisplayStatus = (status: string): string => {
  const statusDisplayMap: Record<string, string> = {
    [REQUEST_STATUS.REQUESTING]: REQUEST_STATUS.PROCESSING,
    [REQUEST_STATUS.QUEUED]: REQUEST_STATUS.PROCESSING,
    [REQUEST_STATUS.FAILED]: REQUEST_STATUS.QUEUED,
  };
  return statusDisplayMap[status] ?? status;
};

/**
 * Returns the i18n label key for a given request status.
 * - F (FAILED) → "PRIVACY_MYDATA_STATUS_REQUESTED"
 * - Q (QUEUED) → "PRIVACY_MYDATA_STATUS_PROCESSING"
 * - W (REQUESTING) → "PRIVACY_MYDATA_STATUS_PROCESSING"
 * - All others use RequestStatusLabel mapping
 */
export const getDisplayLabel = (status: string): string => {
  return RequestStatusLabel[status as REQUEST_STATUS] ?? status;
};

/**
 * Statuses that should be treated as "Requested" category.
 * Used for filtering and counting in Summary and History pages.
 */
export const REQUESTED_STATUSES: string[] = [
  REQUEST_STATUS.QUEUED,
  REQUEST_STATUS.FAILED,
];

/**
 * Checks if a status should be treated as "Requested" category.
 * Returns true for Q (QUEUED) and F (FAILED).
 */
export const isRequestedStatus = (status: string): boolean => {
  return REQUESTED_STATUSES.includes(status);
};
